"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("@firebase/util");
/**
 * Encapsulates the data needed to raise an event
 * @implements {Event}
 */
var DataEvent = /** @class */ (function () {
 /**
 * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
 * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
 * @param {!DataSnapshot} snapshot The data backing the event
 * @param {?string=} prevName Optional, the name of the previous child for child_* events.
 */
 function DataEvent(eventType, eventRegistration, snapshot, prevName) {
 this.eventType = eventType;
 this.eventRegistration = eventRegistration;
 this.snapshot = snapshot;
 this.prevName = prevName;
 }
 /**
 * @inheritDoc
 */
 DataEvent.prototype.getPath = function () {
 var ref = this.snapshot.getRef();
 if (this.eventType === 'value') {
 return ref.path;
 }
 else {
 return ref.getParent().path;
 }
 };
 /**
 * @inheritDoc
 */
 DataEvent.prototype.getEventType = function () {
 return this.eventType;
 };
 /**
 * @inheritDoc
 */
 DataEvent.prototype.getEventRunner = function () {
 return this.eventRegistration.getEventRunner(this);
 };
 /**
 * @inheritDoc
 */
 DataEvent.prototype.toString = function () {
 return (this.getPath().toString() +
 ':' +
 this.eventType +
 ':' +
 util_1.stringify(this.snapshot.exportVal()));
 };
 return DataEvent;
}());
exports.DataEvent = DataEvent;
var CancelEvent = /** @class */ (function () {
 /**
 * @param {EventRegistration} eventRegistration
 * @param {Error} error
 * @param {!Path} path
 */
 function CancelEvent(eventRegistration, error, path) {
 this.eventRegistration = eventRegistration;
 this.error = error;
 this.path = path;
 }
 /**
 * @inheritDoc
 */
 CancelEvent.prototype.getPath = function () {
 return this.path;
 };
 /**
 * @inheritDoc
 */
 CancelEvent.prototype.getEventType = function () {
 return 'cancel';
 };
 /**
 * @inheritDoc
 */
 CancelEvent.prototype.getEventRunner = function () {
 return this.eventRegistration.getEventRunner(this);
 };
 /**
 * @inheritDoc
 */
 CancelEvent.prototype.toString = function () {
 return this.path.toString() + ':cancel';
 };
 return CancelEvent;
}());
exports.CancelEvent = CancelEvent;

//# sourceMappingURL=Event.js.map



//////////////////
// WEBPACK FOOTER
// ../database/dist/cjs/src/core/view/Event.js
// module id = 85
// module chunks = 0